import type { FaireThemeEntity } from "../../entity_types/theme";

export const the_holistic_pantry: FaireThemeEntity = {
  token: "the-holistic-pantry",
  type: "theme",
  name: "The Holistic Pantry",
  description: "High-quality kitchen staples that cater to health-conscious patrons looking for artisanal and pure ingredients.",
  teaser: "Your business prioritizes 'handmade,' 'small-batch,' and 'plant-based' signals. Adding clean pantry essentials fits naturally alongside your current selection of herbal syrups and essential oils.",
  detail: "The additional_context payload includes Hain Pure Foods Sea Salt, demonstrating an interest in sourcing high-quality, trusted pantry basics.",
  bgColor: "#B0C4D4",
  tileBgColor: "#6b5430",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_dxxios8k7k",
    "p_y47sx37yfw",
    "p_c69w1vd0",
    "p_9w2jlrggen",
    "p_4uk1berjzz",
    "p_mg8vnazqqd",
    "p_4q9n6lrs63",
    "p_mgybbmkhb3",
    "p_p54mxt4bqh",
    "p_8dg5atezvw",
    "p_vze4rqdhdd",
    "p_nyerjahvrb",
    "p_5ove7ckfeo",
    "p_yupe7a9nyj",
    "p_2nf9rc7xa4",
    "p_d3p4q7yjqh",
    "p_utpfzacrsz",
    "p_e7wau4yyxd",
    "p_bwqcqbuzbq",
    "p_4vjn8bbj",
    "p_dhk5okud5h",
    "p_7tpkv3ozqp",
    "p_ew3sf3zuqh",
    "p_f8yph6babm",
    "p_myqcm7n9hh",
    "p_4ttxvdz3k8",
    "p_t54e6824e8",
    "p_sadtje7ujt",
    "p_u9hqunyhuv",
    "p_awa23m9fjm",
    "p_kq3hkffnvh",
    "p_7rzdpeq5kt",
    "p_phm78kkqyz",
    "p_ccmdttq9na",
    "p_rbyvfcr35h",
    "p_xhg3pf6ywk",
    "p_3gfcwg334c",
    "p_kzyjhb5msm",
    "p_6bfdexwag7",
    "p_fpvfwuce93",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
